import { getRuleErrorMessage } from "@/utils/formHelper";
import { qrNameValidation } from "./shared";
import { TFunction } from "i18next";
export const qrWhatsappValidation = (data, t: TFunction) => {
  return [
    qrNameValidation(t),
    {
      name: "phone",
      rules: {
        required: {
          value: true,
          message: getRuleErrorMessage("phone", "required", data),
        },
        maxLength: {
          value: 70,
          message: getRuleErrorMessage("phone", "maxLength", data),
        },
      },
    },
    {
      name: "message",
      rules: {
        required: {
          value: true,
          message: getRuleErrorMessage("message", "required", data),
        },
        maxLength: {
          value: 300,
          message: getRuleErrorMessage("message", "maxLength", data),
        },
      },
    },
  ];
};
